import gqlTagGira from 'graphql-tag';

export const SINGLE_LINE_TEXT_FRAGMENT = gqlTagGira`
    fragment jiraSingleLineTextFragment on JiraSingleLineTextField {
        text
    }
`;
